<template>
  <RouterLink class="link text-gray-100 text-lg" :to="to" @click="parentMenuClose()">
    <i class="icon" :class="icon" />
    <transition name="fade">
      <span v-if="!collapsed" class="text-gray-200">
        <slot />
      </span>
    </transition>
  </RouterLink>
</template>
<script>
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import { collapsed } from './state'

export default {
  components: { 
    RouterLink 
  },
  props: {
      to: { type: String, required: true },
      icon: { type: String, required: true },
      menus: { type: Array, required: true }
  },
  setup(props) {
      const isActive = computed(props.to);
      return { isActive, collapsed };
  },
  methods: {
    parentMenuClose() {
      this.$emit("parentMenuClose");
    }
  },
   
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.link {
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  user-select: none;
  padding: 0.7em 0.8em 0.8em 0.8em;
  height: 2.2em;
  text-decoration: none;  
}
.link span{
  font-size: 1rem;
  margin-top: .1rem;
}
.link:hover{
    background-color: var(--color-brandblue);
}
.link.selected{
    background-color: var(--color-brandblue);
    position:relative;
}
.link.selected:after{
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    top: 12px;
    left:-8px;  
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid var(--color-brandblue);
}
.link .icon {
  flex-shrink: 0;
  width: 25px;
  margin-right: 10px;
}
</style>